import JulgamentosAnteriores from '@/components/JulgamentosAnteriores';
import ReactComponent from '@/components/ReactComponent';
import InfoIcon from '@mui/icons-material/Info';
import { Box, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import { inject, observer } from 'mobx-react';

class DetalheSessaoAnterior extends ReactComponent {
    render() {
        const { registro } = this.observableProps;

        if (!registro?.detalhes?.julgamentosAnteriores?.length) {
            return (
                <Box sx={{ pt: 2, pl: 1, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <InfoIcon
                        fontSize="medium"
                        sx={{ color: blue[800] }}
                    />
                    <Typography sx={{ pl: 1, color: blue[800], fontStyle: 'italic' }}>
                        Nenhuma sessão anterior encontrada.
                    </Typography>
                </Box>
            );
        }

        return (
            <JulgamentosAnteriores
                registro={registro}
                variant="select"
                exibirDetalhesInscricoes={true}
            />
        );
    }
}

export default inject('stores')(observer(DetalheSessaoAnterior));
